/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const organisationSearchResultSchema = z.object({
      "codeNs": z.string().describe("Code NS de l'office, au même format que AccountOrganization.codeNs et le claim\nns.codeNs du token (OID datalake sans son préfixe OFFI).\n"),
  "nom": z.string().describe("Nom affiché de l'office (à défaut, son nom légal)"),
  "crpcen": z.string().describe("Code CRPCEN de l'office").optional()
      })